import { IUserRole } from 'pages/Admin/types'

const useIsAdmin = (role: IUserRole) => !!role?.role_id && ["admin"].includes(role.role_id)

export default useIsAdmin
